// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.accounting.feeschedule.UpdateFeeScheduleRangeRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateFeeScheduleRangeRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Begin Date is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	beginDate!: Date;

	@GandalfValidator({ notNull: { message: 'Fee Schedule Range is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	feeScheduleRangeId!: number;

	@GandalfValidator({ notNull: { message: 'Practice Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationId!: number;

	@GandalfValidator({ notNull: { message: 'Write-Off Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	writeOffReasonId!: number;

}
